import { useCallback, useContext, useEffect, useState } from "react";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import { TostMsg } from "../../../../App";
import {
  addEmployeeAddress,
  deleteEmployeeAddress,
  getEmployeeAddress,
} from "../Service/profileService";
import { GetMasterTypeData } from "../../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { Dropdown } from "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const UserRolePermission = ({ employeeId, employee }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const { showLoading, hideLoading } = useContext(LoaderContext);
  const [Isloading, setIsloading] = useState(false);
  const [addressData, setAddressData] = useState([]);
  const toster = useContext(TostMsg);
  const [update, setUpdate] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showContent, setSeleteContent] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [addressId, setAddressId] = useState(0);
  const [countriesList, setCountriesList] = useState(null);
  const defaultImage = "/images/org-img/profile/badge.png";

  useEffect(() => {
    // if (employeeId) {
    //   employeeAddresssList();
    // }
  }, [employeeId]);

  const handleCloseModal = () => {
    // AddressForm.resetForm();
  };

  return (
    <div className="documentdiv">
      <div className="">
        <strong>Role & Permission</strong>
        <p>
          One last step. Check all the access settings to make sure everything
          looks good.
        </p>
        <div className="no-role-assign">
          <LazyImage src="/images/org-img/profile/no-role.png" />
          <p>
            Assign a role to user access to features. Narrow that access with
            permissions.
          </p>
          <button>
            <Link to="ManageUserAccess" className="text-white">
              Set Role & Permission
            </Link>
          </button>
        </div>
        <div className="profileview-role mt-4">
          <h4>Role assigned</h4>
          <p>HR manager</p>
        </div>
        <div className="profileview-permission">
          <h4>Permission</h4>
          <div className="accordion" id="permissonaccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="heading0111">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse0111"
                  aria-expanded="true"
                  aria-controls="collapse0111"
                >
                  Marketing
                </button>
              </h2>
              <div
                id="collapse0111"
                className="accordion-collapse collapse show"
                aria-labelledby="heading0111"
                data-bs-parent="#permissonaccordio"
              >
                <div className="accordion-body">
                  <div className="option">
                    <div className="inner">
                      <p>List</p>
                      <span>
                        <b>View</b>
                        <b>Edit</b>
                      </span>
                    </div>
                    <div className="inner">
                      <p>Form</p>
                      <span>
                        <b>View</b>
                        <b>Edit</b>
                        <b>Create Own</b>
                      </span>
                    </div>
                    <div className="inner">
                      <p>Files</p>
                      <span>
                        <b>View</b>
                        <b>Edit</b>
                        <b>Delete</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="heading0222">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse0222"
                  aria-expanded="false"
                  aria-controls="collapse0222"
                >
                  Permission 01
                </button>
              </h2>
              <div
                id="collapse0222"
                className="accordion-collapse collapse"
                aria-labelledby="heading0222"
                data-bs-parent="#permissonaccordio"
              >
                <div className="accordion-body">
                  <div className="option">
                    <div className="inner">
                      <p>List</p>
                      <span>
                        <b>View</b>
                        <b>Edit</b>
                      </span>
                    </div>
                    <div className="inner">
                      <p>Form</p>
                    </div>
                    <div className="inner">
                      <p>Files</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="heading0333">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse0333"
                  aria-expanded="false"
                  aria-controls="collapse0333"
                >
                  Permission 02
                </button>
              </h2>
              <div
                id="collapse0333"
                className="accordion-collapse collapse"
                aria-labelledby="heading0333"
                data-bs-parent="#permissonaccordio"
              >
                <div className="accordion-body">
                  <div className="option">
                    <div className="inner">
                      <p>List</p>
                      <span>
                        <b>View</b>
                        <b>Edit</b>
                      </span>
                    </div>
                    <div className="inner">
                      <p>Form</p>
                    </div>
                    <div className="inner">
                      <p>Files</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRolePermission;
